import React, { forwardRef } from 'react';
import { color, space, font, radius } from './tokens';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Optional inline label. If omitted, render the input bare and provide your own label. */
  label?: React.ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, disabled, style, ...rest },
  ref,
) {
  const input = (
    <input
      ref={ref}
      type="checkbox"
      disabled={disabled}
      style={{
        width:        16,
        height:       16,
        accentColor:  color.brand.primary,
        cursor:       disabled ? 'not-allowed' : 'pointer',
        margin:       0,
        ...style,
      }}
      {...rest}
    />
  );

  if (!label) return input;

  return (
    <label
      style={{
        display:    'inline-flex',
        alignItems: 'center',
        gap:        space[2],
        fontSize:   font.size.base,
        color:      color.text.secondary,
        cursor:     disabled ? 'not-allowed' : 'pointer',
        opacity:    disabled ? 0.6 : 1,
        // suppress accidental browser-default styling
        borderRadius: radius.sm,
      }}
    >
      {input}
      <span>{label}</span>
    </label>
  );
});

export default Checkbox;
